import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { useLoaderSubscribe } from 'ziphy-web-shared/basic/utils';
import styles from '@nedoShared/modules/notes/ui/sidebarContent/SidebarContent.module.scss';
import ApptDocuments from '@pages/appt/apptDocuments/ApptDocuments';
import { $legacyNotes as $notes } from '../LegacyNotes.store';
const SidebarContent = ({ className }) => {
    const { t } = useTranslation();
    useLoaderSubscribe('open_appt_documents', () => {
        $notes.SET_SIDEBAR('documents');
    });
    if (!$notes.sidebar) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", Object.assign({ id: 'appt_documents', className: classNames(styles.wrapper, className) }, { children: $notes.sidebar === 'documents' && (_jsxs("div", Object.assign({ className: styles.content }, { children: [_jsxs("div", Object.assign({ className: classNames(styles.header, 'mb-20') }, { children: [_jsx(Button, { leftElement: 'moveRightArrow', mode: ['secondary-icon', 'xs', 'justIcon'], onClick: () => $notes.SET_SIDEBAR(null) }), _jsx(Title, Object.assign({ size: 'h2' }, { children: t('label.documents') }))] })), _jsx("div", Object.assign({ className: styles.body }, { children: _jsx(ApptDocuments, { activePatient: $notes.patient, title: false, mode: 'vertical' }) }))] }))) })));
};
export default observer(SidebarContent);
